import React, { FC } from 'react';
import Head from 'next/head';

export const Icons: FC = () => (
  <Head>
    <link href="/static/images/logo_small.png" rel="image_src" />
    <link href="/static/images/favicon.png" rel="shortcut icon" type="image/x-icon" />
    <link href="/static/images/favicon_57.png" rel="apple-touch-icon" />
    <link href="/static/images/favicon_72.png" rel="apple-touch-icon" sizes="72x72" />
    <link href="/static/images/favicon_114.png" rel="apple-touch-icon" sizes="114x114" />
  </Head>
);
